export const falsy = (value) => {
  if (value === false || value === undefined || value === null || value === NaN) {
    return true
  } else {
    return false
  }
}

const idValueToInt = obj => ({ "id": parseInt(obj?.id)})
const quantityValueToInt = obj => ({ "quantity": parseInt(obj?.quantity)})

export const tempDisable = (element, time) => {
  element.setAttribute('disabled', 'true')
  setTimeout(() => {
    element.removeAttribute('disabled')
  }, time)
}

// wrapper for foreach to do some error redundancy
export const each = function (arr, fn) {
  if (arr == undefined) return
  if (arr.length == 0) return
  const array = Array.from(arr)
  array.map(fn)
}

export const dispatchEvent = (target, eventName) => {
  target.dispatchEvent(new CustomEvent(eventName, { bubbles: true }))
}

export const indexOfQuery = (el, string) =>
  Array.prototype.indexOf.call(el.children, el.querySelector(string))

export const selectElement = (select, index) => {
  select.selectedIndex = index
}

export const addClass = (el, className) => el.classList.add(className)
export const removeClass = (el, className) => el.classList.remove(className)
export const toggleClass = (item, cls) => {
  item.classList.toggle(cls)
}

export const stringFalseOrTrue = string => string === 'true'

export const rangeFromZero = int => [...Array(int).keys()]

export const rangeFrom = (min, max) =>
  [...Array(max).keys()].filter(int => int >= min)

export const multiAddToCart = (dataObjectsToAdd, form) => {
  //Shopify api rejects adding two items at the exact same moment, so there needs to be a delay
  let addToCartPromise = Promise.resolve()
  const addToCartInterval = 300
  dataObjectsToAdd.forEach(formData => {
    addToCartPromise = addToCartPromise.then(function () {
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })

      return new Promise(function (resolve) {
        setTimeout(resolve, addToCartInterval)
      })
    })
    // Wait until the loop finishes then a few milliseconds more
  })
  setTimeout(() => {
    window.location.href = '/cart'
  }, addToCartInterval * dataObjectsToAdd.length + 600)
}

export const addMultipleToCart = async (items) => {
  const result = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'items': items})
  })
  console.log(await result.json())
  return result
}

export const getDataFromForm = (form) => {
  const fields = Array.from(form.querySelectorAll('input, select'))
  const inputNameValuePairs = fields.map(field => {
    const input = field?.selectedOptions ? field?.selectedOptions[0] : field
    const inputName = input?.getAttribute('name')
    const inputValue = input?.value
    if (falsy(inputName) && falsy(inputName)) return
    return {
      [inputName]: inputValue
    }
  })
  const idObj = inputNameValuePairs.find(nameValuePair => nameValuePair?.id)
  const quantityObj = inputNameValuePairs.find(nameValuePair => nameValuePair?.quantity)
  const parsedidObj = quantityObj ? idValueToInt(idObj) : idObj
  const parsedQuantityobj = quantityObj ? quantityValueToInt(quantityObj) : quantityObj
  const propertiesObj = inputNameValuePairs
    .filter(valuePairPair => Object.keys(valuePairPair)[0]?.includes('properties')
    )
    .map(propertiesPair => {
      const key = Object
        .keys(propertiesPair)[0].
        replace('properties[', '')
        .replace(']', '')
      const value = Object.values(propertiesPair)[0]
      return { [key]: value }
    })
    .reduce((accu, next) => {
      return { ...accu, ...next }
    }, {})
  return {
    ...parsedidObj,
    ...parsedQuantityobj,
    "properties": {...propertiesObj}
  }
}

export const toggleAttr = (item, attr) =>
  item.hasAttribute(attr)
    ? item.removeAttribute(attr)
    : item.setAttribute(attr, '')

export const setAttr = (attr, value) => item => item.setAttribute(attr, value)
export const getAttr = attr => item => item.getAttribute(attr)
export const hasAttr = attr => item => item.hasAttribute(attr)
export const setHtml = item => html => (item.innerHTML = html)

export const setAriaExpandedTrue = setAttr('aria-expanded', 'true')
export const setAriaExpandedFalse = setAttr('aria-expanded', 'false')

const getAriaExpanded = getAttr('aria-expanded')

export const expandedTrue = elem => {
  return getAriaExpanded(elem) === 'true'
}

export const expandedToggle = elem => {
  expandedTrue(elem) ? setAriaExpandedFalse(elem) : setAriaExpandedTrue(elem)
}

export const moreThan = x => y => y > x
